import React from 'react';

export const questions = [{
  q: <>Will it be free?</>,
  a: 'No, it won’t. We have families to feed, and they get pretty angry if we don’t put food on the table. Plus, we want to create more incredible games like this, and funding helps make that possible.'
}, {
  q: 'Will there be a single-player mode?',
  a: 'No, Parallel Experiment is designed as a co-op experience and therefore it is not possible to play in single player mode. Playing with friends, family or colleagues allows for diverse problem-solving puzzles, and pushes our players to communicate well together and think outside the box.'
}, {
  q: 'What\'s the difference between Parallel Experiment and Parallel Lab?',
  a: 'These are two completely different games. Parallel Experiment is a new title available on PC, iOS, and Android, while Parallel Lab is an online escape room game we designed a few years ago.'
}, {
  q: 'I want to cover your game!',
  a: 'That’s awesome! Reach out to us at contact@elevenpuzzles.com, and we’ll be happy to work something out.'
}];
